import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'sm-checkbox',
  templateUrl: './sm-checkbox.component.html',
  styleUrls: ['./sm-checkbox.component.scss']
})
export class SmCheckboxComponent {
  @Input() classes: string;
  @Input() label: string;
  @Input() labelFor: string;
  @Input() checked: any;
  @Input() id: any = null;
  @Input()
  get inputModel() {
    return this.value;
  }
  set inputModel(val) {
    this.value = val;
    this.inputModelChange.emit(this.value);
  }

  @Output() inputModelChange = new EventEmitter<any>();
  @Output() onChange = new EventEmitter<any>();
  value = null;

  /** `checked` wins when the consumer binds it one-way; otherwise `inputModel` is the source of truth. */
  get isChecked(): boolean {
    return this.checked !== undefined && this.checked !== null ? !!this.checked : !!this.value;
  }

  onCheckboxChange(e: Event) {
    this.inputModel = !!(e as CustomEvent<{ checked: boolean }>).detail.checked;
    this.onChange.emit();
  }
}
